import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';

@Component({
  selector: 'custom-product-loading',
  templateUrl: './product-loading.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
// This component is used to get the context of individual product line items of quick order and show the loading while loading the product
export class ProductLoadingComponent implements OnInit {
  loading$: Observable<boolean>;

  constructor(private context: ProductContextFacade) {}

  ngOnInit(): void {
    this.loading$ = this.context.select('loading');
  }
}
